import React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Stack,
  Typography,
  Button,
  StepConnector,
  useTheme,
  useMediaQuery,
  StepContent,
  Paper,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { StepperComponent } from "@/components";
import { IMAGES, WEB_COLORS} from "@/lib/constants";
import Image from "next/image";
import ContentHeader from "../ContentHeader/ContentHeader";

const steps = [
  {
    label: "Verify your details",
    description:
      "Enter your basic info to get started with your loan application.",
    icon: IMAGES.roundedPersonalDetail,
  },
  {
    label: "Complete KYC",
    description:
      "Quickly verify your identity through a secure online process.",
    icon: IMAGES.fingerprint,
  },
  {
    label: "Work Detail",
    description:
      "Share your employment and income details to help assess eligibility.",
    icon: IMAGES.roundedWorkDetails,
  },
  {
    label: "Re-Payment Setup",
    description: "Choose your repayment mode and set up auto-debit securely.",
    icon: IMAGES.roundedWalletPayment,
  },
  {
    label: "E-sign",
    description: "Review and digitally sign your loan agreement with ease.",
    icon: IMAGES.roundedEsign,
  },
  {
    label: "Get the loan",
    description: "Sit back as the approved amount is credited to your account.",
    icon: IMAGES.roundedLendMoney,
  },
];

const CustomStepIcon = ({ icon, mobileView }) => (
  <Box
    sx={{
      width: { xs: 10, md: "100%" },
      height: { xs: 10, md: "100%" },
      border: { xs: "1px solid #004135", lg: "none" },
      backgroundColor: { xs: "#00F200", lg: "transparent" },
      borderRadius: "50%",
      mr:{xs:2.5, md:'auto'},
      ml:{xs:1,md:"auto"},

    }}
  >
    {!mobileView && <Image src={icon} width={30}></Image>}
  </Box>
);

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#4caf50",
  },
}));
const ApplicationStepper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      sx={{
        backgroundColor: {
          xs: "#fff",
          md: "#f1fdf6",
        },
        py: { xs: 2, md: 5 },
        px: { xs: 2, md: 5 },
        borderBottomRightRadius: "40px",
        borderBottomLeftRadius: "40px",
      }}
    >
      <ContentHeader
        heading={"How To Apply For Personal Loan"}
        paragraph={`Wondering how to apply for a Personal Loan? Applying for a Personal Loan
        online has never been easier. By completing a quick and secure online
        application process, you can find an easy and accessible way to secure
        instant funds.`}
      />

      <Box>
        <Stepper
          orientation={isMobile ? "vertical" : "horizontal"}
          alternativeLabel={!isMobile}
          connector={<CustomConnector />}
          activeStep={-1}
          nonLinear = {isMobile}
        >
          {steps.map((step, index) => (
            <Step key={index}>
              <StepLabel
                StepIconComponent={() => (
                  <CustomStepIcon icon={step.icon} mobileView={isMobile} />
                )}
              >
                {!isMobile && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {step?.label}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {step?.description}
                    </Typography>
                  </>
                )}
                {isMobile && (
                  <Box
                    sx={{
                      p: 1,
                      border: { xs: "1px solid #CCD6D4", md: "none" },
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: { xs: "row", md: "column" },
                      justifyContent: { xs: "flex-start", md: "center" },
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box>
                      <Image src={step.icon} width={30} />
                    </Box>

                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {step?.label}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {step.description}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Button variant="contained" size="large" sx={{ backgroundColor:WEB_COLORS.darkTeal}} fullWidth={isMobile}>
          <Typography color={"#fff"} textTransform={'none'}>

          Apply Now
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default ApplicationStepper;
